import appconfig from './appconfig';
import axios from 'axios';

function getRepos(username) {
    return axios.get('https://api.github.com/users/' + username + '/repos');
}

function getUserInfo(username) {
    return axios.get('https://api.github.com/users/' + username);
}

function getContactEmailParams(formParams) {
    return {
        SmtpServerUrl: appconfig.smtpServer.url,
        SmtpServerPort: appconfig.smtpServer.port,
        SmtpServerUsername: appconfig.smtpServer.username,
        SmtpServerPassword: appconfig.smtpServer.password,
        From: formParams.From,
        To: appconfig.contactMail.to,
        Subject: appconfig.contactMail.subjecprefix + formParams.Subject,
        Message: formParams.Message
    }
}

const api = {
    getGithubInfo: function (username) {
        return axios.all([getRepos(username), getUserInfo(username)])
            .then(function (arr) {
                return {
                    repos: arr[0].data,
                    bio: arr[1].data
                }
            })
    },
    sendContactEmail: function (emailparam) {
        //let apiUrl = appconfig.apibaseurl + 'sendmail';
        let params = getContactEmailParams(emailparam);

        return axios({
            baseURL: 'http://localhost:1313/',
            url: '/sendmail',
            method: 'POST', 
            data: params,
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                console.log(response);
                //return response.data;
                return true;
            })
            .catch(function (error) {
                console.log("errore" + error);
                return false;
            });
    }
}

export default api;


// WEBPACK FOOTER //
// ./src/utils/api.js